import React from "react";
import { UserRound } from "lucide-react";

export default function DefaultAvatarPlaceholder({ className = "", iconClassName = "" }) {
  return (
    <div className={`w-full h-full rounded-full bg-gradient-to-br from-emerald-50 to-green-100 dark:from-emerald-900/40 dark:to-green-900/30 text-emerald-700 dark:text-emerald-300 flex items-center justify-center ${className}`}>
      <UserRound className={`w-1/2 h-1/2 ${iconClassName}`} />
    </div>
  );
}
